// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.files-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.5); /* oscuro translúcido */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(6px);
}

.popup-content {
  background: #1f2937;
  color: #f1f5f9;
  padding: 24px;
  width: 420px;
  border-radius: 16px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.35);
  text-align: center;
  animation: fadeIn 0.2s ease-in-out;
  position: relative;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.close-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #334155;
  color: #e2e8f0;
  font-size: 12px;
  font-weight: bold;
  border: none;
  position: absolute;
  right: 16px;
  top: 16px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-popup:hover {
  background-color: #475569;
  transform: scale(1.1);
}

.popup-content h2 {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
  color: #f8fafc;
}

ul {
  list-style: none;
  padding: 0;
  max-height: 300px;
  overflow-y: auto;
  border-top: 1px solid #334155;
  margin-top: 10px;
  padding-top: 10px;
}

ul::-webkit-scrollbar {
  width: 6px;
}

ul::-webkit-scrollbar-thumb {
  background-color: #4970ad;
  border-radius: 3px;
}

ul::-webkit-scrollbar-track {
  background-color: #1e293b;
}

.file-item {
  background: #2b3544;
  color: #e2e8f0;
  border: none;
  width: 100%;
  padding: 12px;
  text-align: left;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.25s ease-in-out;
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
}

.file-item:hover {
  background: rgba(59, 130, 246, 0.15); /* azul translúcido */
}

.file-item svg {
  color: #94a3b8;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/FilesPopup/FilesPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC,EAAE,uBAAuB;EAC1D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".files-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 23, 42, 0.5); /* oscuro translúcido */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(6px);\n}\n\n.popup-content {\n  background: #1f2937;\n  color: #f1f5f9;\n  padding: 24px;\n  width: 420px;\n  border-radius: 16px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  animation: fadeIn 0.2s ease-in-out;\n  position: relative;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.close-popup {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #334155;\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: bold;\n  border: none;\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.close-popup:hover {\n  background-color: #475569;\n  transform: scale(1.1);\n}\n\n.popup-content h2 {\n  margin-bottom: 15px;\n  font-size: 20px;\n  font-weight: bold;\n  color: #f8fafc;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: auto;\n  border-top: 1px solid #334155;\n  margin-top: 10px;\n  padding-top: 10px;\n}\n\nul::-webkit-scrollbar {\n  width: 6px;\n}\n\nul::-webkit-scrollbar-thumb {\n  background-color: #4970ad;\n  border-radius: 3px;\n}\n\nul::-webkit-scrollbar-track {\n  background-color: #1e293b;\n}\n\n.file-item {\n  background: #2b3544;\n  color: #e2e8f0;\n  border: none;\n  width: 100%;\n  padding: 12px;\n  text-align: left;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: background 0.25s ease-in-out;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n.file-item:hover {\n  background: rgba(59, 130, 246, 0.15); /* azul translúcido */\n}\n\n.file-item svg {\n  color: #94a3b8;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
